module.exports = __webpack_public_path__ + "media/typy/osobowe@2x-b2169293.png";